import { useMemo } from 'react';

import useStatsigGate from 'modules/common/useStatsigGate';
import { FeatureGates } from 'modules/common/constants/featuregates';

export const useImpactAdvocateEnabled = () => {
    const isGateEnabled = useStatsigGate(FeatureGates.ImpactAdvocateEnabled);

    const isEnabled = useMemo(() => {
        return isGateEnabled;
    }, [isGateEnabled]);

    return isEnabled;
};
